<template>
  <div style="position: relative; z-index: 999999">
    <component
      :is="component"
      v-for="(component, key) in MODALS_COMPONENTS_MAP"
      :ref="key"
      :key="key"
      :payload="modal.payload"
      @close="freeModal"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import {MODALS} from "../constants";
import {MUTATIONS} from "@frontend/store/file-browser-product-selector";
import {isArray} from "lodash";
import {createModal} from "./action-creater";
import CropModal from "./CropModal.vue";
import RemoveBackgroundModal from "./RemoveBackgroundModal.vue";

const { mapGetters, mapMutations } = createNamespacedHelpers('fileBrowserProductSelector')

const MODALS_COMPONENTS_MAP = {
  [MODALS.CROP]: CropModal,
  [MODALS.REMOVE_BACKGROUND]: RemoveBackgroundModal,
}

// Default z-index for normal usage (not nested in GenAI modal)
const BOOTSTRAP_MODAL_DEFAULT_ZINDEX = 1060;
// Higher z-index when used inside GenAI modal flow (Product Library has z-index 1065)
const BOOTSTRAP_MODAL_GENAI_ZINDEX = 1070;
const Z_INDEX_INCREMENT = 5;

export default {
  name: "AllModals",
  computed: {
    ...mapGetters(['modal']),
    MODALS_COMPONENTS_MAP() {
      return MODALS_COMPONENTS_MAP;
    },
  },
  watch: {
    modal(modal, prev) {
      if (!modal.type) {
        this.close(prev.type)
        return;
      }

      this.init(modal.type)
    }
  },
  mounted() {
    // When used with "bootstrap" modal, the z-index of "bootstrap-vue" modal is smaller, so we need to manually increase it
    this.$root.$on('bv::modal::show', (_, modalId) => {
      this.$nextTick(() => {
        if (!Object.keys(MODALS).includes(modalId)) {
          return;
        }

        const modalOuter = document.getElementById(`${modalId}___BV_modal_outer_`);

        if (!modalOuter) {
          return;
        }

        // Remove any existing style to allow dynamic z-index updates
        const existingStyle = document.querySelector(`style[data-modal-id="${modalId}"]`);
        if (existingStyle) {
          existingStyle.remove();
        }

        // Check if we're in the GenAI modal context (Product Library opened from GenAI modal)
        const isGenAIContext = $('#addProductImages').data('selecting-for-gen-ai') === true;
        const baseZIndex = isGenAIContext ? BOOTSTRAP_MODAL_GENAI_ZINDEX : BOOTSTRAP_MODAL_DEFAULT_ZINDEX;

        const style = document.createElement('style');
        style.setAttribute('data-modal-id', modalId);

        style.innerHTML = `
          #${modalId}___BV_modal_outer_ {
            z-index: ${baseZIndex + Z_INDEX_INCREMENT} !important;
          }
        `;

        document.head.appendChild(style);
      });
    });
  },
  methods: {
    ...mapMutations([MUTATIONS.SET_MODAL]),
    init(ref) {
      const _ref = isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref];

      if (!_ref) {
        throw new Error(`There is no modal with ref ${ref}`)
      }

      _ref.init()
    },
    close(ref) {
      const _ref = isArray(this.$refs[ref]) ? this.$refs[ref][0] : this.$refs[ref];
      if (_ref) {
        _ref.close()
      }
    },
    freeModal() {
      this[MUTATIONS.SET_MODAL](createModal())
    }
  }
}
</script>

<style scoped lang="scss">
</style>
